import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { queryClient } from '@lib/queryClient';
import { DsExternalProvider } from '@providers/DsExternalProvider';
import { routeTree } from './routeTree.gen';
import '@styles/global.scss';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <DsExternalProvider>
        <RouterProvider router={router} />
      </DsExternalProvider>
    </QueryClientProvider>
  </StrictMode>,
);
